import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {
    BigintDeliverableDisplayDecimalPipe
} from '../../components/bigint-display-decimal-pipe/bigint-deliverable-display-decimal.pipe';
import {BigintDisplayDecimalPipe} from '../../components/bigint-display-decimal-pipe/bigint-display-decimal.pipe';
import {DexTrancheUtilityModule} from '../../components/dex/dex-tranche-utility/dex-tranche-utility.module';
import {DelBalanceAsyncPipe} from '../../components/dex/dyn-balances/del-balance-async.pipe';
import {DisplayDecimalModule} from '../../components/display-decimal';
import {WIDGET_DESCRIPTIONS} from '../../components/layout/widget/widget-registry.service';
import {PartialLoadingIndicatorModule} from '../../components/partial-loading-indicator';
import {ResponsiveColsModule} from '../../components/responsive-cols/responsive-cols.module';
import {SelectInputModule} from '../../components/select-input';
import {L10nModule} from '../../components/translate';
import {AutofocusModule} from '../../directives/autofocus';
import {SparklineModule} from '../../mobile/pages/m-quotes-page/m-quotes-mini-chart/sparkline';
import {DynAuthWidgetBodyComponent} from '../components/dyn-auth-widget-body/dyn-auth-widget-body.component';
import {
    DexTrancheDetailsStandaloneComponent
} from '../dex-lp-widget/standalone/dex-tranche-details-standalone/dex-tranche-details-standalone.component';
import {DexTrancheActionsComponent} from './dex-tranche-actions/dex-tranche-actions.component';
import {DexTrancheComposComponent} from './dex-tranche-compos/dex-tranche-compos.component';
import {DexTrancheDetailsWidgetComponent} from './dex-tranche-details-widget.component';
import {DEX_TRANCHE_DETAILS_WIDGET_DESCRIPTION} from './dex-tranche-details-widget.description';
import {DexTrancheSparklinePipe} from './dex-tranche-sparkline.pipe';
import {DexTrancheDetailsWidgetSettingsComponent} from './settings/dex-tranche-details-widget-settings.component';
import {DexTrancheDetailsWidgetSettingsService} from './settings/dex-tranche-details-widget-settings.service';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        L10nModule,
        AutofocusModule,
        PartialLoadingIndicatorModule,
        DynAuthWidgetBodyComponent,
        SparklineModule,
        DisplayDecimalModule,
        BigintDisplayDecimalPipe,
        DexTrancheComposComponent,
        DexTrancheActionsComponent,
        SelectInputModule,
        ResponsiveColsModule,
        DelBalanceAsyncPipe,
        BigintDeliverableDisplayDecimalPipe,
        DexTrancheSparklinePipe,
        DexTrancheUtilityModule,
        DexTrancheDetailsStandaloneComponent
    ],
    declarations: [
        DexTrancheDetailsWidgetComponent,
        DexTrancheDetailsWidgetSettingsComponent
    ],
    exports: [
        DexTrancheDetailsWidgetComponent
    ],
    providers: [
        DexTrancheDetailsWidgetSettingsService,
        {
            provide:  WIDGET_DESCRIPTIONS,
            useValue: DEX_TRANCHE_DETAILS_WIDGET_DESCRIPTION,
            multi:    true
        }
    ]
})
export class DexTrancheDetailsWidgetModule {}
